import script from "./QModalRfidChoose.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalRfidChoose.vue?vue&type=script&setup=true&lang=js"

import "./QModalRfidChoose.vue?vue&type=style&index=0&id=de2fa6ae&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de2fa6ae"]])

export default __exports__